import { render, staticRenderFns } from "./TransitionCollapse.vue?vue&type=template&id=3901894b&scoped=true&"
import script from "./TransitionCollapse.vue?vue&type=script&lang=js&"
export * from "./TransitionCollapse.vue?vue&type=script&lang=js&"
import style0 from "./TransitionCollapse.vue?vue&type=style&index=0&id=3901894b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3901894b",
  null
  
)

export default component.exports